import axios from "axios";
export const addUser = (body: any) =>
  axios.post("https://3l9pc99heh.execute-api.us-east-2.amazonaws.com/dev/user", body);
export const getPresignedUrl = () =>
  axios.get("https://3l9pc99heh.execute-api.us-east-2.amazonaws.com/dev/user/presigned-url");
